export type Origin = 'JP' | 'DE' | 'US' | 'IT' | 'GB' | 'FR' | 'SE' | 'KR';
// F4/M4/R4 = front/mid/rear-engine AWD. 'AWD' is the legacy pre-split code —
// kept so an already-materialized puzzle payload still typechecks; the worker
// stopped serving it once the canon split shipped.
export type Layout = 'FF' | 'FR' | 'MR' | 'RR' | 'F4' | 'M4' | 'R4' | 'AWD';
export type Aspiration = 'NA' | 'Turbo' | 'TT' | 'SC';
export type BodyStyle =
  | 'coupe'
  | 'sedan'
  | 'hatch'
  | 'roadster'
  | 'wagon'
  | 'suv'
  | 'truck'
  | 'van';
export type EngineConfig = 'inline' | 'vee' | 'flat' | 'rotary';

export interface Specs {
  year: number;
  origin: Origin;
  layout: Layout;
  engine_config?: EngineConfig;
  cylinders: number | null;
  aspiration: Aspiration;
  power_hp: number;
  weight_kg: number;
  body_style: BodyStyle;
}

// Canon entry as served by /decode/canon (no fun_fact).
export interface CanonGuess {
  id: string;
  label: string;
  aliases: string[];
  specs: Specs;
}

// The answer entry (decoded from base64 payload.answer) includes fun_fact.
export interface AnswerEntry extends CanonGuess {
  fun_fact: string;
  cars_slug?: string;
}

export type AxisState =
  | 'exact'
  // Numeric near-miss (amber). Carries direction so the board shows ▲/▼ on
  // close cells too — answer is slightly higher / lower than the guess.
  | 'close_higher'
  | 'close_lower'
  | 'higher'
  | 'lower'
  | 'match'
  | 'wrong';

export interface GuessFeedback {
  era: AxisState;
  origin: AxisState;
  layout: AxisState;
  body_style: AxisState;
  cylinders: AxisState;
  aspiration: AxisState;
  power: AxisState;
  weight: AxisState;
}

export const AXES = [
  'era', 'origin', 'layout', 'body_style', 'cylinders', 'aspiration', 'power', 'weight',
] as const;
export type Axis = (typeof AXES)[number];

export const MAX_GUESSES = 9;

export interface AssembledPuzzle {
  id: string;
  number: number;
  answer: string; // base64(JSON.stringify(AnswerEntry))
}

export interface BoardResponse {
  puzzle: AssembledPuzzle;
  date: string;
  result: { solved: boolean; guesses: number; guessesLog: string[] } | null;
}
